import { call, put, takeEvery, takeLatest } from 'redux-saga/effects';
import { MODERATION_ACTION_TYPES } from './moderationActionTypes';
import { moderationServices } from './moderationServices';
import {
  fetchModerationListSuccess,
  fetchModerationListFailure,
  approveUserSuccess,
  approveUserFailure,
  rejectUserSuccess,
  rejectUserFailure,
  updateModerationRowFailure,
  updateModerationRowSuccess,
  fetchEmployeesListSuccess,
  fetchEmployeesListFailure,
  setActiveModerationTab,
  fetchApprovedUsers
} from './moderationActions';
import { failToast, succToast } from '../../../helper/ApiToast';
import { userDetailsLocal } from '../../../helper/RoleConfig';

function* fetchModerationListSaga(action) {
  const { entityType, filters } = action.payload;

  try {
    const userDetails = userDetailsLocal() || {};
    const { data: { organisationId = 0 } = {} } = userDetails;

    const response = yield call(
      moderationServices.fetchModerationList,
      entityType,
      organisationId,
      filters
    );

    if ((response?.data?.status && response?.data?.status !== 200) || response?.status !== 200) {
       throw new Error(response.message);
    }

    yield put(fetchModerationListSuccess(entityType, response));

  } catch (error) {
    const errorMessage = error.response?.data?.message || 'Failed to fetch data';
    yield put(fetchModerationListFailure(entityType, errorMessage));
    failToast(errorMessage);
  }
}
function* approveUserRequestSaga(action) {
  const { requestId, assignmentData } = action.payload;

  try {
    const response = yield call(
      moderationServices.approveUserRequest,
      assignmentData
    );

    const isArray = Array.isArray(assignmentData);
    const firstItem = isArray ? assignmentData[0] : assignmentData;
    const shouldRefresh = isArray
      ? assignmentData.some(item => item?.status === 'reassigned')
      : assignmentData?.status === 'reassigned';

    const statusCode = response?.data?.status || response?.status;
    const message = response?.data?.message || response?.message || '';

    if (statusCode !== 200) {
      throw new Error(message || `Failed to approve user (status: ${statusCode})`);
    }

    yield put(approveUserSuccess(requestId, response));

    succToast(message || 'User approved successfully!');

    const dynamicData = {
      tabNameToRefresh: 'approvedUsers',
      userId: isArray ? firstItem?.userId : assignmentData?.userId,
      empName: isArray ? assignmentData.map(item => item?.empName) : assignmentData?.empName,
      status: isArray ? firstItem?.status : assignmentData?.status
    };

    yield put(setActiveModerationTab('approvedusers', shouldRefresh, dynamicData));
    yield put(fetchApprovedUsers({}));

  } catch (error) {
    const errorMessage =
      error.response?.data?.message ||
      error.message ||
      'Failed to approve user';

    yield put(approveUserFailure(requestId, errorMessage));
    failToast(errorMessage);
  }
}

function* rejectUserRequestSaga(action) {
  const { requestId, payload } = action.payload;

  try {
    const response = yield call(
      moderationServices.rejectUserRequest,
      payload
    );

    const statusCode = response?.data?.status || response?.status;
    const message = response?.data?.message || response?.message || '';

    if (statusCode !== 200) {
      throw new Error(message || `Failed to reject user (status: ${statusCode})`);
    }

    yield put(rejectUserSuccess(requestId, response));
    succToast(message || 'User rejected successfully');

    yield put(setActiveModerationTab('rejectedusers', false));

  } catch (error) {

    const errorMessage =
      error.response?.data?.message ||
      error.message ||
      'Failed to reject user';

    yield put(rejectUserFailure(requestId, errorMessage));
    failToast(errorMessage);
  }
}

function* fetchEmployeesListSaga(action) {

  const { requestId, filters } = action.payload;

  try {
    const userDetails = userDetailsLocal() || {};
    const { data: { organisationId = 0 } = {} } = userDetails;

    const response = yield call(
      moderationServices.fetchEmployeesList,
      organisationId,
      filters
    );

    yield put(fetchEmployeesListSuccess(requestId, response));

  } catch (error) {
    const errorMessage = error.response?.data?.message || 'Failed to fetch employees';
    yield put(fetchEmployeesListFailure(requestId, errorMessage));
    failToast(errorMessage);
  }
}

function* updateModerationRowSaga(action) {
  const { entityType, userId, updateData } = action.payload;

  try {
    const userDetails = userDetailsLocal() || {};
    const { data: { organisationId = 0 } = {} } = userDetails;

    const response = yield call(
      moderationServices.updateModerationRow,
      entityType,
      organisationId,
      userId,
      updateData
    );

    if ((response?.data?.status && response?.data?.status !== 200) || response?.status !== 200) {
       throw new Error(response.message);
    }

    yield put(updateModerationRowSuccess(entityType, userId, updateData));

    if (response.message) {
      succToast(response.message);
    }

  } catch (error) {
    const errorMessage =
      error.response?.data?.message ||
      error.message ||
      `Failed to update ${entityType}`;

    yield put(updateModerationRowFailure(entityType, userId, errorMessage));
    failToast(errorMessage);
  }
}

function* moderationSaga() {
  yield takeLatest(MODERATION_ACTION_TYPES.FETCH_MODERATION_LIST, fetchModerationListSaga);
  yield takeEvery(MODERATION_ACTION_TYPES.UPDATE_MODERATION_ROW, updateModerationRowSaga);
  yield takeEvery(MODERATION_ACTION_TYPES.APPROVE_USER_REQUEST, approveUserRequestSaga);
  yield takeEvery(MODERATION_ACTION_TYPES.REJECT_USER_REQUEST, rejectUserRequestSaga);
  yield takeLatest(MODERATION_ACTION_TYPES.FETCH_EMPLOYEES_LIST, fetchEmployeesListSaga);
}

export default moderationSaga;
